/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsShiftPauseInput } from "../../entities/models/ShiftPauseInput";
import { z } from "zod/v4";

export const modelsShiftPauseInputSchema = z.object({
    "shift_id": z.int()
    }) as unknown as z.ZodType<ModelsShiftPauseInput>